import { render } from "./editTemplateProposalComponent.vue?vue&type=template&id=4190f3fe&scoped=true"
import script from "./editTemplateProposalComponent.vue?vue&type=script&lang=js"
export * from "./editTemplateProposalComponent.vue?vue&type=script&lang=js"

import "./editTemplateProposalComponent.vue?vue&type=style&index=0&id=4190f3fe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4190f3fe"]])

export default __exports__